import { createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer, createTransform } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import * as Sentry from '@sentry/browser'
import createSentryMiddleware from 'redux-sentry-middleware'
import * as subscribers from './subscribers'

import reducers from '../reducers'

const clearFetchIds = createTransform(
  pertsistState => ({
    ...pertsistState
  }),
  rehydrateState => ({
    ...rehydrateState,
    fetchId: null
  }),
  { whitelist: ['client', 'home', 'buyerInfo'] }
)

const persistConfig = {
  key: 'root',
  storage,
  transforms: [clearFetchIds],
  whitelist: ['client', 'customerProfile', 'home', 'buyerInfo']
}

const persistedReducer = persistReducer(persistConfig, reducers)

const store = createStore(
  persistedReducer,
  {},
  composeWithDevTools(
    applyMiddleware(
      thunk,
      createSentryMiddleware(Sentry, {
        stateTransformer: state => {
          return {}
        }
      })
    )
  )
)

Object.values(subscribers).forEach(createSubscriber => {
  const subscriber = createSubscriber(store)
  store.subscribe(subscriber)
})

export const persistor = persistStore(store)
export default store
